"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyConverterEpics = void 0;

var _utils = require("@alycecom/utils");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var _currencyConverter = require("./currencyConverter.actions");

var currencyConverterEpic = function currencyConverterEpic(action$, state$, _ref) {
  var apiService = _ref.apiService;
  return action$.pipe((0, _utils.ofType)(_currencyConverter.convertCurrencyRequest), (0, _operators.mergeMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        id = _ref2$payload.id,
        params = _ref2$payload.params;
    return apiService.post("/api/v1/currencies/convert", {
      body: params
    }, true).pipe((0, _operators.map)(function (_ref3) {
      var data = _ref3.data;
      return (0, _currencyConverter.convertCurrencySuccess)({
        id,
        conversions: data
      });
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(function () {
      return (0, _currencyConverter.convertCurrencyFail)({
        id
      });
    }))));
  }));
};

var currencyConverterEpics = [currencyConverterEpic];
exports.currencyConverterEpics = currencyConverterEpics;